import React from "react";
import { Badge } from "@shadcn-in-nx/ui/badge";

function ChangesSummary({ inserts = [], updates = new Map(), deletes = new Set() }) {
    const insertCount = inserts.length;
    const updateCount = updates.size;
    const deleteCount = deletes.size;

    if (insertCount === 0 && updateCount === 0 && deleteCount === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 text-sm">
            {insertCount > 0 && (
                <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                    +{insertCount} new
                </Badge>
            )}
            {updateCount > 0 && (
                <Badge variant="outline" className="bg-orange-50 text-orange-700 border-orange-200">
                    {updateCount} modified
                </Badge>
            )}
            {deleteCount > 0 && (
                <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                    -{deleteCount} deleted
                </Badge>
            )}
        </div>
    );
}

export default ChangesSummary;
